export const TYPE_ISSUED_INVOICES = 1
export const TYPE_RECEIVED_INVOICES = 2
export const TYPE_ISSUED_CREDIT_NOTES = 3
export const TYPE_RECEIVED_CREDIT_NOTES = 4
